// Add your custom JS here.
( function( $ ) {

    AOS.init();




    // parallax elements
    var image = document.getElementsByClassName('parallax-one');
    new simpleParallax(image, {
        scale: 1.4,
        overflow: true,
    });

    var image = document.getElementsByClassName('parallax-two');
    new simpleParallax(image, {
        scale: 1.8,
        overflow: true,
    });

    var image = document.getElementsByClassName('parallax-three');
    new simpleParallax(image, {
        scale: 2.2,
        overflow: true,
    });

    var image = document.getElementsByClassName('parallax-four');
    new simpleParallax(image, {
        scale: 2.6,
        overflow: true,
    });
   



    // image slider
    var swiper = new Swiper(".spaces-swiper", {
        slidesPerView: "auto",
        center: true,
        loop: false,
        spaceBetween: 20,
        initialSlide: 3,
        pagination: {
            el: ".spaces-pagination",
            clickable: true,
            renderBullet: function (index, className) {
                return '<span class="' + className + '"></span>';
            },
        },
        navigation: {
            nextEl: ".swiper-next",
            prevEl: ".swiper-prev",
        },
        breakpoints: {
            768: {
              spaceBetween: 40,
            },
            1024: {
              spaceBetween: 40,
            },
          },
    });




    // check if page is scrolled from the top for header
    $(document).scroll(function(){
	    if($(this).scrollTop() > 50)
	    {   
	        $('#wrapper-navbar').removeClass('header-top');

	    }
	    if($(this).scrollTop() < 50)
	    {   
	        $('#wrapper-navbar').addClass('header-top');
	    }
	});




    // show header based on scroll directions
    var lastScrollTop = 0;
	$(window).scroll(function(event){
        var st = $(this).scrollTop();
        if (st > lastScrollTop){
            $('#wrapper-navbar').removeClass('show');
        } else {
            $('#wrapper-navbar').addClass('show');
        }
        lastScrollTop = st;
	});

    
    $('iframe').addClass("youtube-iframe");

    $(".video-popup .cross").click(function() {
      $('.youtube-iframe').each(function(index) {
        $(this).attr('src', $(this).attr('src'));
        return false;
      });
      
//click function
    });


    // video popup
    $('.button.play').on('click', function(e) {
        $('.video-popup').addClass('active');
    });




    // video popup close
    $('.video-popup .cross').on('click', function(e) {
        $('.video-popup').removeClass('active');
    });




    // tab switch right
    $('.switch .tab-one').on('click', function(e) {
        $('.section-three').removeClass('active');
    });




    // tab switch left
    $('.switch .tab-two').on('click', function(e) {
        $('.section-three').addClass('active');
    });




    // toggle menu
    $('.menu-toggle').on('click', function(e) {
        $('.header-right').addClass('active');
        $('#wrapper-navbar').addClass('stop');
    });

    $('.menu-close').on('click', function(e) {
        $('.header-right').removeClass('active');
        $('#wrapper-navbar').removeClass('stop');
    });

    $('.menu-item').on('click', function(e) {
        $('.header-right').removeClass('active');
        $('#wrapper-navbar').removeClass('stop');
    });


    // add class to menu items based on scroll position
    $(window).scroll(function() {
        var hT = $('#project').offset().top,
            hH = $('#project').outerHeight(),
            wH = $(window).height() + 400,
            wS = $(this).scrollTop();
         console.log((hT-wH) , wS);
        if (wS > (hT+hH-wH)){
            $('.menu li').removeClass('active');
            $('.menu li.project').addClass('active');
        }
     });

     $(window).scroll(function() {
        var hT = $('#location').offset().top,
            hH = $('#location').outerHeight(),
            wH = $(window).height() + 400,
            wS = $(this).scrollTop();
         console.log((hT-wH) , wS);
        if (wS > (hT+hH-wH)){
            $('.menu li').removeClass('active');
            $('.menu li.location').addClass('active');
        }
     });

     $(window).scroll(function() {
        var hT = $('#building').offset().top,
            hH = $('#building').outerHeight(),
            wH = $(window).height() + 400,
            wS = $(this).scrollTop();
         console.log((hT-wH) , wS);
        if (wS > (hT+hH-wH)){
            $('.menu li').removeClass('active');
            $('.menu li.building').addClass('active');
        }
     });

     $(window).scroll(function() {
        var hT = $('#download').offset().top,
            hH = $('#download').outerHeight(),
            wH = $(window).height() + 400,
            wS = $(this).scrollTop();
         console.log((hT-wH) , wS);
        if (wS > (hT+hH-wH)){
            $('.menu li').removeClass('active');
            $('.menu li.download').addClass('active');
        }
     });

     $(window).scroll(function() {
        var hT = $('#contact').offset().top,
            hH = $('#contact').outerHeight(),
            wH = $(window).height() + 1000,
            wS = $(this).scrollTop();
         console.log((hT-wH) , wS);
        if (wS > (hT+hH-wH)){
            $('.menu li').removeClass('active');
            $('.menu li.contact').addClass('active');
        }
     });




     // smooth onpage anchor scrolling
    $('a[href^="#"]').click(function(){
        $('html, body').animate({
            scrollTop: $( $(this).attr('href') ).offset().top
        }, 500);
        return false;
    });


} )( jQuery );